(() => {
  const selector = 'bundle-selector';

  function ensureInput(form, name, dataName) {
    let input = Array.from(form.elements).find((element) => element.name === name);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.dataset.bundleSelectorInput = dataName;
      form.appendChild(input);
    }

    return input;
  }

  function selectColor(bundle, selectedButton) {
    if (!selectedButton) return;

    const selectedValue = selectedButton.dataset.optionValue;
    const selectedLabel = selectedButton.dataset.colorLabel || selectedValue || '';
    const variantId = selectedButton.dataset.variantId;
    const colorInput = bundle._bundleColorInput;

    bundle._bundleColorButtons.forEach((button) => {
      const isSelected = button.dataset.optionValue === selectedValue;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (colorInput) {
      colorInput.value = selectedLabel;
    }

    if (variantId) {
      document.querySelectorAll('input.product-variant-id[name="id"]').forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  function syncForm(bundle, card) {
    const quantity = Math.max(1, Number(card.dataset.quantity || 1));
    const title = card.querySelector('.product-bundle-selector__title')?.textContent?.trim() || '';

    bundle._bundleQuantityInput.value = String(quantity);
    bundle._bundleQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    bundle._bundlePropertyInput.value = title ? `${title} (${quantity})` : String(quantity);

    const visibleQuantity = document.querySelector(`#Quantity-${bundle.dataset.productFormId.replace('product-form-', '')}`);
    if (visibleQuantity) {
      visibleQuantity.value = String(quantity);
      visibleQuantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncColorForCard(bundle, card) {
    if (card.dataset.fixedColor) {
      bundle._bundleColorInput.value = card.dataset.fixedColor;
      return;
    }

    selectColor(bundle, card.querySelector('[data-bundle-color].is-selected') || card.querySelector('[data-bundle-color]'));
  }

  function selectCard(bundle, selectedCard) {
    bundle._bundleCards.forEach((card) => {
      const isSelected = card === selectedCard;
      card.classList.toggle('is-selected', isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    syncForm(bundle, selectedCard);
    syncColorForCard(bundle, selectedCard);
  }

  function stepQuantity(bundle, card, step) {
    const minimum = Number(card.dataset.quantityMinimum || card.dataset.quantity || 1);
    const current = Number(card.dataset.quantity || minimum);
    const next = Math.max(minimum, current + step);

    card.dataset.quantity = String(next);
    card.querySelector('[data-bundle-quantity]').textContent = String(next);
    selectCard(bundle, card);
  }

  function initBundle(bundle) {
    if (!bundle || bundle.dataset.bundleInitialized === 'true') return;

    const form = document.getElementById(bundle.dataset.productFormId);
    const cards = Array.from(bundle.querySelectorAll('[data-bundle-card]'));

    if (!form || !cards.length) {
      window.setTimeout(() => initBundle(bundle), 50);
      return;
    }

    bundle.dataset.bundleInitialized = 'true';
    bundle._bundleCards = cards;
    bundle._bundleColorButtons = Array.from(bundle.querySelectorAll('[data-bundle-color]'));
    bundle._bundleQuantityInput = ensureInput(form, 'quantity', 'quantity');
    bundle._bundlePropertyInput = ensureInput(form, 'properties[_Bundle]', 'bundle_property');
    bundle._bundleColorInput = ensureInput(form, 'properties[_Color]', 'color_property');

    cards.forEach((card) => {
      card.dataset.quantityMinimum = card.dataset.quantity || '1';

      card.addEventListener('click', (event) => {
        if (event.target.closest('[data-bundle-minus], [data-bundle-plus], [data-bundle-color]')) return;
        selectCard(bundle, card);
      });

      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (event.target.closest('[data-bundle-color]')) return;
        event.preventDefault();
        selectCard(bundle, card);
      });

      card.querySelector('[data-bundle-minus]')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        stepQuantity(bundle, card, -1);
      });

      card.querySelector('[data-bundle-plus]')?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        stepQuantity(bundle, card, 1);
      });
    });

    bundle._bundleColorButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const card = button.closest('[data-bundle-card]');
        if (card) selectCard(bundle, card);
        selectColor(bundle, button);
      });
    });

    const defaultCard = bundle.querySelector(`[data-bundle-card][data-tier="${bundle.dataset.defaultTier}"]`);
    selectCard(bundle, bundle.querySelector('[data-bundle-card].is-selected') || defaultCard || cards[0]);
  }

  function initAll(root = document) {
    root.querySelectorAll(selector).forEach(initBundle);
  }

  if (window.customElements && window.HTMLElement && !window.customElements.get(selector)) {
    window.customElements.define(
      selector,
      class BundleSelector extends HTMLElement {
        connectedCallback() {
          initBundle(this);
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
